import { useState, useCallback } from 'react';
import useEventListener from '../../components/common/useEventListener';

export const useDemoSettingsModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  const toggleModal = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  // Handle keyboard shortcut to open modal
  const handleKeyDown = useCallback((event: KeyboardEvent) => {
    // F2 to toggle modal (safe across all browsers and platforms)
    if (event.key === 'F2') {
      event.preventDefault();
      toggleModal();
    }
  }, [toggleModal]);

  useEventListener('keydown', handleKeyDown);

  return {
    isOpen,
    openModal,
    closeModal,
    toggleModal,
  };
};
